import { useCallback } from 'react';

/**
 * Hook to copy a link to clipboard, replacing the subdomain with the current subdomain
 */
export const useCopyLink = () => {
  const copyLinkToClipboard = useCallback((url: string) => {
    if (!url) return;

    // Replace the subdomain with the current subdomain (including port)
    const currentHostname = window.location.hostname;
    const currentPort = window.location.port;
    const urlObj = new URL(url);
    urlObj.hostname = currentHostname;
    urlObj.port = currentPort;

    navigator.clipboard.writeText(urlObj.toString());
  }, []);

  return { copyLinkToClipboard };
};
